export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  BOOKING: "/booking",
  CONTACT: "/contact",
  POPULAR_DESTINATIONS: "/popular-destinations",
  GASTRONOMY_AND_WINE: "/gastronomy-and-wine",
  OUTDOOR_ACTIVITIES: "/outdoor-activities",
  GUEST_STORIES: "/guest-stories",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms-of-use",
  CREDITS: "/credits",
  NOT_FOUND: "/404",
} as const;

export type TPagePath = (typeof ROUTES)[keyof typeof ROUTES];

// oxlint-disable-next-line import/no-default-export
export default {
  ROUTES,
};